import type { Cycle } from "./cycles";
import { formatUnitDisplayTitle } from "./formatUnitDisplayTitle";

export interface FlattenedCriterionItem {
  key: string;
  unitId: string;
  unitTitle: string;
  elementId: string;
  elementTitle: string;
  type: "demonstrate" | "explain";
  index: number;
  text: string;
}

/** Flatten cycle into assessable criteria with stable keys. */
export function flattenCriteria(cycle: Cycle): FlattenedCriterionItem[] {
  const out: FlattenedCriterionItem[] = [];
  for (const unit of cycle.units) {
    for (const element of unit.elements) {
      element.demonstrate.forEach((c, i) => {
        out.push({
          key: `${unit.id}:${element.id}:demo:${i}`,
          unitId: unit.id,
          unitTitle: formatUnitDisplayTitle(unit),
          elementId: element.id,
          elementTitle: element.title,
          type: "demonstrate",
          index: i,
          text: c,
        });
      });
      element.explain.forEach((c, i) => {
        out.push({
          key: `${unit.id}:${element.id}:explain:${i}`,
          unitId: unit.id,
          unitTitle: formatUnitDisplayTitle(unit),
          elementId: element.id,
          elementTitle: element.title,
          type: "explain",
          index: i,
          text: c,
        });
      });
    }
  }
  return out;
}
